module.exports = __webpack_public_path__ + "img/teamImg28.7adb5cc7.jpg";